import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const studentNutritionService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-nutrition/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching student nutrition list", error);
            throw error;
        }
    },

    async findById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/student-nutrition/findById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById student nutrition", error);
            throw error;
        }
    },

    async save(student: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-nutrition/save`,
                student
            );
            return response.data;
        } catch (error) {
            console.error("Error save student nutrition", error);
            throw error;
        }
    },

    async uploadCsv(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-nutrition/upload-nutrition-csv`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error upload nutrition csv", error);
            throw error;
        }
    },
}

export default studentNutritionService;